import {Grid, IconButton} from '@mui/material'
import {NotificationMessage} from '../NotificationMessages/NotificationMessages'
import React, {ReactNode} from 'react'
import {Close} from '@mui/icons-material'
import {useDeleteNotificationMutation} from '../rtkNotificationApi'
import {
    createDateFromUnixTimestamp,
    formatDateDayjs,
    formatTimeDayjs,
    fromNowDayjs
} from '../../../../genericComponents/date/DateService'
import {NotificationDTO} from '../../../../generated/api'

const GenericNotificationDisplay = ({
    notification,
    title,
    canClose,
    children,
    body,
    actions
}: {
    notification: NotificationDTO
    title: string
    canClose: boolean
    children?: ReactNode
    body?: ReactNode
    actions?: ReactNode
}) => {
    const [deleteNotification, deleteNotificationResult] = useDeleteNotificationMutation()

    const dateToDisplay: Date = createDateFromUnixTimestamp(notification.createdDate)

    const date = () => {
        const notificationDate = formatDateDayjs(dateToDisplay)
        const notificationTime = formatTimeDayjs(dateToDisplay)
        const timeFromNow = fromNowDayjs(dateToDisplay)

        return (
            <div className="notification-time">
                {notificationDate && `${notificationDate} | ${notificationTime} - ${timeFromNow}`}
            </div>
        )
    }

    return (
        <Grid className="datx-notification-item" container>
            <div className="notification-container">
                <div className="notification-col notification-body">
                    <div className="notification-title">{title}</div>
                    <div className="notification-content">
                        <NotificationMessage notification={notification} />
                    </div>
                    {body}
                    {date()}
                    {actions}
                    {children}
                </div>
                <div className={'notification-col notification-control ' + (!canClose ? 'hidden' : '')}>
                    <IconButton
                        size="small"
                        onClick={() => deleteNotification(notification.id)}
                        disabled={deleteNotificationResult.isLoading}
                    >
                        <Close />
                    </IconButton>
                </div>
            </div>
        </Grid>
    )
}

export default GenericNotificationDisplay
